import { Box, Stack, createStyles } from '@mantine/core';
import { useMemo } from 'react';
import {
	fetchCatalogList,
	useCatalogInfiniteList,
} from '../../../../api/hooks/resourceCatalog';

import { TableV2 } from '../../../../components/TableV2';

import { EntityType } from '@repo/common/enums/entityType';
import { useCatalogFilter } from '../../../../components/Filter/useCatalogFilter';
import {
	useActions,
	useColumns,
} from '../../../TeamCatalogPage/TeamCatalogPage.hooks';

const useStyles = createStyles(() => ({
	gridWrapper: {
		width: '100%',
		minHeight: 350,
		flexGrow: 1,
	},
	tableWrapper: {
		height: '100%',
	},
}));

interface SigmaPagesTabProps {
	id: string;
}

const COLUMN_VISIBILITY = {
	catalogType: EntityType.dashboard,
	catalogServerType: EntityType.dashboard,
} as const;

const DEFAULT_SEARCH_PARAMS = {
	entity_type: EntityType.dashboard,
	calculate_children_count: true,
} as const;

const DEFAULT_SEARCH_PARAMS_NESTING = {
	entity_type: EntityType.dashboard,
	calculate_children_count: true,
} as const;

function SigmaPagesTab({ id }: SigmaPagesTabProps) {
	const columns = useColumns();
	const actions = useActions();

	const { classes } = useStyles();

	const defaultCatalogFilters = useMemo(
		() => ({
			operands: [
				{
					operands: [],
					field: 'parent_id' as const,
					operator: 'exact' as const,
					value: id,
				},
				{
					operands: [],
					field: 'native_type' as const,
					operator: 'exact' as const,
					value: 'page',
				},
			],
		}),
		[id]
	);

	const filterOptions = useCatalogFilter();

	return (
		<Stack className={classes.gridWrapper}>
			<Box className={classes.tableWrapper}>
				<TableV2
					key={columns.length}
					withSearch
					withInteractiveHeader
					withCsvExport
					withServerCsvExport
					withCheckbox
					withActions={actions}
					columns={columns}
					withInfiniteScroll
					withFilterOptions={filterOptions}
					usePaginationList={useCatalogInfiniteList}
					fetchPaginationList={fetchCatalogList}
					columnVisibility={COLUMN_VISIBILITY}
					defaultRequiredSearchParams={DEFAULT_SEARCH_PARAMS}
					defaultRequiredSearchParamsNesting={DEFAULT_SEARCH_PARAMS_NESTING}
					defaultRequiredCatalogFilters={defaultCatalogFilters}
					nestingFilter="parent_id"
				/>
			</Box>
		</Stack>
	);
}

export default SigmaPagesTab;
